import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { noop } from 'lodash-es';
import { TrackingConstant } from 'client/tracking/constant';

import './heart-button.scss';

export function HeartButton({
  onClick = noop,
  trackingId = null,
  trackingValue = null,
  disabled = false,
  active = false,
  ariaLabelExtra = '',
}) {
  return (
    <button
      className={classNames('heart-button p-0 border-0 bg-white rounded-circle mt-0_5 me-0_5', { active })}
      disabled={disabled}
      onClick={onClick}
      data-tracking-id={trackingId}
      data-tracking-value={trackingValue}
      data-subaction-name={active ? TrackingConstant.UNSAVE_VIN : TrackingConstant.SAVE_VIN}
      title={active ? 'Click to remove' : 'Click to save'}
      aria-label={active ? `Click to remove favorite ${ariaLabelExtra}` : `Click to save favorite ${ariaLabelExtra}`}
      aria-pressed={active}
    >
      <span className="d-flex h-100 justify-content-center align-items-center">
        <i
          className={classNames('heart-button-icon d-inline-block', active ? 'icon-heart3' : 'icon-heart4')}
          aria-hidden
        />
      </span>
    </button>
  );
}

HeartButton.propTypes = {
  onClick: PropTypes.func,
  trackingId: PropTypes.string,
  trackingValue: PropTypes.string,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  ariaLabelExtra: PropTypes.string,
};
